
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-screener/guide",
      function () {
        return require("private-next-pages/stock-screener/guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-screener/guide"])
      });
    }
  